import { render, staticRenderFns } from "./editar-beneficio.vue?vue&type=template&id=734d8192&"
import script from "./editar-beneficio.vue?vue&type=script&lang=ts&"
export * from "./editar-beneficio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('734d8192')) {
      api.createRecord('734d8192', component.options)
    } else {
      api.reload('734d8192', component.options)
    }
    module.hot.accept("./editar-beneficio.vue?vue&type=template&id=734d8192&", function () {
      api.rerender('734d8192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/beneficio/editar-beneficio.vue"
export default component.exports